/**
 * Extract a user-friendly error message from Spring Boot HTTP error responses.
 * Checks body.message, body.errorMessage, body.error.message, a string body.error
 * (invoice-api `InvoiceAPIError`, whose `message` is null), and raw string body.
 */
export function extractErrorMessage(err: any, fallback: string): string {
  if (!err) return fallback;
  const body = err.error || err;
  const candidates = [
    body?.message,
    body?.errorMessage,
    body?.error?.message,
    typeof body?.error === 'string' ? body.error : null,
    typeof body === 'string' ? body : null,
    err.message,
  ].filter((v): v is string => typeof v === 'string' && v.trim().length > 0);
  if (candidates.length === 0) return fallback;
  const status = err.status ? ` (HTTP ${err.status})` : '';
  return `${fallback}: ${candidates[0]}${status}`;
}
